export const LogoMark = ({ className = 'h-6 w-6' }) => (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
        <rect x="1" y="1" width="30" height="30" rx="8" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" />
        <rect x="9.5" y="17" width="3" height="7" rx="1.5" fill="#00E5FF" />
        <rect x="14.5" y="11" width="3" height="13" rx="1.5" fill="#00E5FF" opacity="0.8" />
        <rect x="19.5" y="7" width="3" height="17" rx="1.5" fill="#00E5FF" opacity="0.55" />
    </svg>
);
